<template>
    <oc-page title="Enter password">
        <div class="auth-box" id="enter-pass">

            <template v-if="$root.customerLogo !== false">
                <img :src="$root.customerLogo" alt="Customer logo" class="customer-logo" />
                <div class="hr"></div>
            </template>

            <oc-flash-messages />

            <h4 class="section-title">Enter Password</h4>
            <div class="hr mb-5"></div>

            <div class="auth-account-box auth-box-static mb-3" :class="'object-color-' + color">
                <div class="beacon-container beacon-big">
                    <div class="auth-beacon" :class="{'beacon-loading': loading}">
                        <i class="glyphicon glyphicon-user user-icon"></i>
                        <div class="auth-beacon-border"></div>
                    </div>
                </div>
                <div class="auth-account-info">
                    <div class="pull-left">
                        <p class="m-0 account-username" :title="user.username" :class="{center: !user.email}"><b>{{user.username}}</b></p>
                        <p class="m-0 account-email" :title="user.email" v-if="user.email"><i>{{user.email}}</i></p>
                    </div>
                </div>
            </div>

            <div class="clearfix"></div>

            <div class="infobox infobox-error mt-4" v-if="hasFormErrors">
                <span class="icon error-16"></span>
                <p class="mb-0" v-if="formGlobalErrorMessage.length > 0">{{formGlobalErrorMessage}}</p>
                <p class="mb-0" v-else>{{formErrorMessage}}</p>

                <ul class="mt-1 mb-0 pl-3" v-if="Object.keys(formFieldErrors).length > 0">
                    <li v-for="(msg, field) of formFieldErrors" :key="field">
                        <template v-if="msg.indexOf(form.getFieldLabel(field)) === 0">
                            {{msg}}
                        </template>
                        <template v-else>
                            {{form.getFieldLabel(field)}}: {{msg}}
                        </template>
                    </li>
                </ul>
            </div>

            <oc-form :model="form" @submit.native.prevent="doSignIn" class="mt-4">

                <oc-form-field
                    target="password"
                    :input="passwordComponent"
                    :inputAttrs="{required: true}"
                    label="Password"
                    :displayLabel="false"
                    placeholder="Password"
                    :inputPrepend="{component: 'i', attrs: {class: 'glyphicon glyphicon-lock'}}"
                    :inputAppend="{
                        component: 'i',
                        attrs: {class: ['show-pass glyphicon', passwordIcon], title: 'Show password'},
                        on: {mousedown: showPassword, mouseleave: hidePassword, mouseup: hidePassword}
                    }"
                    :indicationValid="false"
                    :required="false"
                />

                <captcha
                    v-if="loginAttempts >= captchaOnLoginAttempts"
                    :url="captchaImageURL"
                    :fieldAttrs="{displayLabel: false, placeholderPrefix: ''}"
                />

                <div class="clearfix" />

                <oc-submit-button-input class="mt-4 btn btn-info btn-block" :disabled="loading">
                    <oc-icon type="sign-in" />
                    Sign in
                </oc-submit-button-input>

                <oc-button-input v-if="$root.authInfo.users.length > 1" class="mt-3 btn btn-default btn-block" @click="chooseAccount">
                    <oc-icon type="user-circle" />
                    Select another account
                </oc-button-input>

                <oc-button-input v-else class="mt-3 btn btn-default btn-block" @click="addAccount">
                    <oc-icon type="user-plus" />
                    Add another account
                </oc-button-input>

            </oc-form>
        </div>
    </oc-page>
</template>

<script>
import AuthStateMixin from '@/mixins/AuthStateMixin'
import SignInMixin from '@/pages/auth/mixins/SignInMixin'

export default {
    name: "enter-pass",
    mixins: [AuthStateMixin, SignInMixin],
    props: {
        username: {
            type: String
        },
        color: {
            type: String,
            default: 'silver'
        }
    },
    data() {
        return {
        }
    },
    created() {
        this.form.username = this.username
    },
    computed: {
        user() {
            let user = {}

            this.$root.authInfo.users.forEach(currentUser => {
                if( currentUser.username === this.username ) {
                    user = currentUser
                }
            })

            return user
        }
    },
    methods: {
        chooseAccount() {
            this.$router.push({
                path: 'choose-an-account'
            })
        },
        addAccount() {
            this.$router.push({
                path: '/login',
                query: {
                    force: 1
                }
            })
        }
    }
}
</script>
